// Copyright 2021 Prescryptive Health, Inc.

import { useContext } from 'react';
import { ILocationContext, LocationContext } from './location.context';

export const useLocationContext = (): ILocationContext =>
  useContext(LocationContext);
